'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const Alert = {
	base: "kEmTa",
	whenInlineFalse: "vYs7Z",
	message: "tu6Hs",
	messageSecondary: "Drmka",
	icon: "xjdh-",
	button: "lc7w3",
	toggle: "cUCnE",
	toggleMessage: "HeUI1",
	closeIcon: "ncSOs"
};
const AlertInline = {
	base: "Rw7Sn"
};
const AlertTypeEnums = [
	"success",
	"info",
	"warning",
	"danger"
];
const AlertTypes = {
	success: "Rv1II",
	info: "zGsE-",
	warning: "k2KDp",
	danger: "Om24r"
};

exports.Alert = Alert;
exports.AlertInline = AlertInline;
exports.AlertTypeEnums = AlertTypeEnums;
exports.AlertTypes = AlertTypes;
